module.exports = __webpack_public_path__ + "static/media/g6.73ebb846.jpg";